import { render, staticRenderFns } from "./OrdenDeServicioLiquidarTable.vue?vue&type=template&id=01a044fa"
import script from "./OrdenDeServicioLiquidarTable.vue?vue&type=script&lang=js"
export * from "./OrdenDeServicioLiquidarTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports